import React from 'react';
import ReactDOM from 'react-dom';
import '../App.css';

export default function Experience() {
    return (
        <div className="experiencesSection" id="experiences">
            <div className="experiencesContainer">
                <div className="innerExperiencesContainer">
                    <div className="experiencesTitling">
                        <p className="experiencesTitle">WORK EXPERIENCE</p>
                    </div>
                    <div className="experiencesGrids">
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Jr. Web Developer</p>
                                <p className="experienceLocation">Grand Communication Networks</p>
                                <p className="experienceLocation">Mission Viejo, CA</p>
                                <p className="experienceDates">January 2023 - Present</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Working with developers and dealer relations manager to maintain and exapnd the current selection of website templates and their various derivatives. Primarily working with C#, JavaScript, and HTML/CSS to maintain the structure of the various front and back end components of web templates and GrandCom's WordPress-based backend admin systems.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">.NET</p>
                                        <p className="stackTools">C#</p>
                                        <p className="stackTools">JavaScript</p>
                                    </div>
                                    <div className="innerStackGrid-lower">
                                        <p className="stackTools">HTML/CSS</p>
                                        <p className="stackTools">WordPress</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Software Development Intern</p>
                                <p className="experienceLocation">Lawrence Livermore National Laboratory</p>
                                <p className="experienceLocation">LivIT SMSG Team</p>
                                <p className="experienceLocation">Livermore, CA</p>
                                <p className="experienceDates">June - August 2022</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Worked with developers and IT staff to as a computing scholar program intern on the LivIT team. Primarily worked with mentor and Mac services team on a redesign and rebuild of the Mac services website using Django, Bootstrap, and Highcharts.js. Mac services website will be used to observe various management statistics of all Macs in use.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">Django</p>
                                        <p className="stackTools">Python</p>
                                        <p className="stackTools">SQLite3</p>
                                    </div>
                                    <div className="innerStackGrid-lower">
                                        <p className="stackTools">Jamf MDM API</p>
                                        <p className="stackTools">Highcharts.js</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Webmaster / Web-Developer</p>
                                <p className="experienceLocation">CSUF Theta Tau</p>
                                <p className="experienceLocation">Phi Epsilon Chapter</p>
                                <p className="experienceLocation">Fullerton, CA</p>
                                <p className="experienceDates">Jan - Dec 2021</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Developed and Rebuilt entire website with HTML, CSS, and JavaScript to accommodate chapter needs. Maintained chapter website while adding additional features to better represent our chapter. Expanded website functionality to properly format for use on multiple devices. Worked with team of students on various large projects during development.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">Figma</p>
                                        <p className="stackTools">HTML/CSS</p>
                                        <p className="stackTools">JavaScript</p>
                                    </div>
                                </div>
                                <div className="experienceCodebuttonContainer">
                                    <div className="codeButton">
                                        <a className="codeBtn" target="_blank" href="https://github.com/CSUFThetaTau-web/CSUFThetaTau-web.github.io">Source Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Summer Research Assistant</p>
                                <p className="experienceLocation">ASSURE-US CSUF</p>
                                <p className="experienceLocation">California State University Fullerton</p>
                                <p className="experienceLocation">Fullerton, CA</p>
                                <p className="experienceDates">Jun - Aug 2021</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Conducted research for the National Science Foundation through Cal State Fullerton's ASSURE-US Program. Attempted to reduce redundancy and load of machine learning on GPUs and accelerate their performance by using YolOX. Aim to train most efficient and accurate model for our overall project so as not to have exuberant computational requirements.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">Python</p>
                                        <p className="stackTools">PyTorch</p>
                                        <p className="stackTools">Weights&Biases</p>
                                    </div>
                                    <div className="innerStackGrid-lower">
                                        <p className="stackTools">Roboflow</p>
                                        <p className="stackTools">YolOX</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Undergrad Research Assistant</p>
                                <p className="experienceLocation">California State University Fullerton</p>
                                <p className="experienceLocation">Intelligent Computing Lab</p>
                                <p className="experienceLocation">Fullerton, CA</p>
                                <p className="experienceDates">Mar - Aug 2021</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Funded by Department of Defense to optimize real time image processing for a self-navigating vehicle with a team of undergraduate and graduate students. Experimented with the PyTorch / Anaconda based machine learning system YoLOv5 to train and identify static and moving people and other objects in images and videos compiled by Stanford University. 
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                <div className="innerStackGrid">
                                        <p className="stackTools">Python</p>
                                        <p className="stackTools">PyTorch</p>
                                        <p className="stackTools">Weights&Biases</p>
                                    </div>
                                    <div className="innerStackGrid-lower">
                                        <p className="stackTools">Roboflow</p>
                                        <p className="stackTools">YolOv5</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
